export default __webpack_public_path__ + "static/media/love.9295deda.png";